import { B } from "../constants";

export default function Terms() {
  return (
    <div style={{minHeight:"100vh",background:B.bg,color:B.textSec,fontFamily:"IBM Plex Sans,sans-serif",padding:"40px 24px",maxWidth:640,margin:"0 auto"}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500&display=swap');*{box-sizing:border-box;margin:0;padding:0}`}</style>
      <a href="/" style={{fontSize:11,letterSpacing:"0.2em",color:B.accent,textTransform:"uppercase",fontWeight:600,textDecoration:"none",fontFamily:"IBM Plex Mono,monospace"}}>FYNWELL</a>
      <h1 style={{fontSize:22,fontWeight:600,color:B.text,margin:"16px 0 24px",fontFamily:"IBM Plex Mono,monospace"}}>Terms of Service</h1>
      <p style={{fontSize:11,color:B.muted,marginBottom:24}}>Effective: March 2026</p>

      <Section title="What Fynwell is">
        <p>Fynwell is a household financial intelligence tool operated by SAVD BY AI LLC ("we", "us", "our"). It helps you see patterns in your spending, detect idle cash, track subscriptions, and organize business expenses - all in one place.</p>
        <p>By using Fynwell, you agree to these terms. If you do not agree, please do not use the service.</p>
      </Section>

      <Section title="Not financial advice">
        <p style={{padding:"12px 16px",background:`${B.accent}14`,border:`1px solid ${B.border}`,borderRadius:8,marginBottom:12}}>
          <strong style={{color:B.accent}}>Important:</strong> Fynwell is not a financial advisor, tax professional, or licensed investment advisor. The insights, recommendations, and information provided through Fynwell are for informational purposes only and do not constitute financial, tax, legal, or investment advice. Always consult a qualified professional before making financial decisions.
        </p>
      </Section>

      <Section title="Your account">
        <ul>
          <li>You must be at least 18 years old and a US resident to use Fynwell</li>
          <li>You are responsible for keeping your login credentials secure</li>
          <li>You are responsible for all activity that occurs under your account</li>
          <li>You agree to provide accurate information when creating your account</li>
        </ul>
      </Section>

      <Section title="Your responsibilities">
        <ul>
          <li>Use Fynwell only for lawful purposes</li>
          <li>Do not attempt to access other users' data or circumvent security controls</li>
          <li>Do not reverse engineer, decompile, or disassemble any part of the service</li>
          <li>Do not use automated tools to scrape or extract data from Fynwell</li>
          <li>Verify any financial information with your bank or financial institution before acting on it</li>
        </ul>
      </Section>

      <Section title="Third-party services">
        <p>Fynwell integrates with third-party services including Plaid (for bank connections) and others. Your use of these services is subject to their own terms and privacy policies. We are not responsible for the availability or accuracy of third-party services.</p>
      </Section>

      <Section title="Gmail integration">
        <p>If you connect your Gmail account, Fynwell reads email headers and subjects only to detect financial events (bills, statements, receipts). Email body content is never stored. You can disconnect Gmail at any time from Settings. Gmail access uses Google's limited use requirements and OAuth with the gmail.readonly scope.</p>
      </Section>

      <Section title="Intellectual property">
        <p>All content, features, and functionality of Fynwell - including text, graphics, logos, and software - are owned by SAVD BY AI LLC and protected by applicable intellectual property laws. You may not copy, modify, distribute, or create derivative works from any part of the service without our written permission.</p>
      </Section>

      <Section title="Limitation of liability">
        <p>To the fullest extent permitted by law, SAVD BY AI LLC and its officers, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of Fynwell. This includes, without limitation, damages for lost profits, lost data, or financial losses resulting from reliance on information provided by the service.</p>
        <p>Our total liability for any claim arising from your use of Fynwell shall not exceed the amount you paid us (if any) in the 12 months preceding the claim.</p>
      </Section>

      <Section title="Service availability">
        <p>We strive to keep Fynwell available at all times, but we do not guarantee uninterrupted access. We may modify, suspend, or discontinue any part of the service at any time without notice. We are not liable for any downtime or service interruptions.</p>
      </Section>

      <Section title="Termination">
        <p>You may stop using Fynwell and delete your account at any time. We may also suspend or terminate your access if you violate these terms or if we determine that your use poses a risk to the service or other users.</p>
        <p>Upon termination, your right to use Fynwell ceases immediately. Sections on limitation of liability, intellectual property, and governing law survive termination.</p>
      </Section>

      <Section title="Changes to these terms">
        <p>We may update these terms from time to time. If we make material changes, we will notify you through the app or by email. Your continued use of Fynwell after changes take effect constitutes acceptance of the updated terms.</p>
      </Section>

      <Section title="Governing law">
        <p>These terms are governed by the laws of the State of California, without regard to conflict of law principles. Any disputes arising from these terms or your use of Fynwell shall be resolved in the courts located in Santa Clara County, California.</p>
      </Section>

      <Section title="Contact">
        <p>For questions about these terms:</p>
        <p style={{marginTop:8}}><strong>Email:</strong> <a href="mailto:hello@getfynwell.ai" style={{color:B.cyan,textDecoration:"none"}}>hello@getfynwell.ai</a></p>
        <p><strong>Entity:</strong> SAVD BY AI LLC</p>
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{marginBottom:28}}>
      <h2 style={{fontSize:15,fontWeight:600,color:B.text,marginBottom:10,fontFamily:"IBM Plex Mono,monospace"}}>{title}</h2>
      <div style={{fontSize:13,lineHeight:1.7,color:B.textSec}}>{children}</div>
      <style>{`
        div ul, div ol { padding-left: 20px; margin: 8px 0; }
        div li { margin-bottom: 6px; }
        div p { margin-bottom: 8px; }
      `}</style>
    </div>
  );
}
